import Vue from 'vue'
import title from './fragments/title'

const area = 'dashboard.cardAppointment.'
const translate = (data) => Vue.i18n.translate(data)

const meetAddress = (data) => {
  const meetingLocation = data?.meeting_location_description

  if (!meetingLocation) return ''

  return `
    <details>
      ${title(translate(area + 'meetingAddress'))}
      <content>
        <h6 class="text-uppercase grey--text">
          ${translate(area + 'address')}
        </h6>
        <p class="body-2 mb-3">
          ${meetingLocation}
        </p>
      </content>
    </details>
  `
}

export default meetAddress
